import React from "react";
import locale from 'locale';
import * as constants from '../../constants';
import { getMemberSuggestions } from '../../../../../../api/cp';
import { participantFormFields } from "../../models";
import FormControlLanguage from "../../../../UI/FormControlLanguage";
import InputSuggestions from '../../../../UI/InputSuggestions';
import { Col, ControlLabel, FormControl, FormGroup, Row } from "react-bootstrap";

const ParticipantFields = (
    {
        eventKey,
        model,
        formErrors,
        onChange,
    }
) => {
    return (
        <FormGroup>
            <FormGroup>
                <ControlLabel>{participantFormFields[constants.FIELD_LASTNAME]}</ControlLabel>
                <FormControlLanguage
                    type="text"
                    placeholder="Введите фамилию"
                    values={{
                        ru: model?.[constants.PARTICIPANT_LASTNAME_RU] || '',
                        en: model?.[constants.PARTICIPANT_LASTNAME_EN] || '',
                    }}
                    onChange={{
                        ru: (e) => onChange(constants.PARTICIPANT_LASTNAME_RU, e.target.value),
                        en: (e) => onChange(constants.PARTICIPANT_LASTNAME_EN, e.target.value),
                    }}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>{participantFormFields[constants.FIELD_NAME]}</ControlLabel>
                <FormControlLanguage
                    type="text"
                    placeholder="Введите имя"
                    values={{
                        ru: model?.[constants.PARTICIPANT_NAME_RU] || '',
                        en: model?.[constants.PARTICIPANT_NAME_EN] || '',
                    }}
                    onChange={{
                        ru: (e) => onChange(constants.PARTICIPANT_NAME_RU, e.target.value),
                        en: (e) => onChange(constants.PARTICIPANT_NAME_EN, e.target.value),
                    }}
                    inValid={!!formErrors.name}
                />
                <span
                    style={{
                        fontSize: '0.75em',
                        color: formErrors.name ? 'red' : 'inherit'
                    }}
                >
                    Поле обязательно для заполнения (длина строки от 2-х символов)
                </span>
            </FormGroup>
            <FormGroup>
                <ControlLabel>{participantFormFields[constants.FIELD_PATRONYMIC]}</ControlLabel>
                <FormControlLanguage
                    type="text"
                    placeholder="Введите отчество"
                    values={{
                        ru: model?.[constants.PARTICIPANT_PATRONYMIC_RU] || '',
                        en: model?.[constants.PARTICIPANT_PATRONYMIC_EN] || '',
                    }}
                    onChange={{
                        ru: (e) => onChange(constants.PARTICIPANT_PATRONYMIC_RU, e.target.value),
                        en: (e) => onChange(constants.PARTICIPANT_PATRONYMIC_EN, e.target.value),
                    }}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>{participantFormFields[constants.FIELD_COMPANY]}</ControlLabel>
                <InputSuggestions
                    eventKey={eventKey}
                    apiCallback={getMemberSuggestions}
                    onSelect={(value) => onChange(
                        constants[locale.currentLocaleName === 'ru' ? 'PARTICIPANT_COMPANY_RU' : 'PARTICIPANT_COMPANY_EN'],
                        value
                    )}
                >
                    <FormControlLanguage
                        type="text"
                        placeholder="Введите название организации"
                        values={{
                            ru: model?.[constants.PARTICIPANT_COMPANY_RU] || '',
                            en: model?.[constants.PARTICIPANT_COMPANY_EN] || '',
                        }}
                        onChange={{
                            ru: (e) => onChange(constants.PARTICIPANT_COMPANY_RU, e.target.value),
                            en: (e) => onChange(constants.PARTICIPANT_COMPANY_EN, e.target.value),
                        }}
                    />
                </InputSuggestions>
            </FormGroup>
            <FormGroup>
                <ControlLabel>{participantFormFields[constants.FIELD_REGALIA]}</ControlLabel>
                <FormControlLanguage
                    type="text"
                    placeholder="Введите регалии"
                    values={{
                        ru: model?.[constants.PARTICIPANT_REGALIA_RU] || '',
                        en: model?.[constants.PARTICIPANT_REGALIA_EN] || '',
                    }}
                    onChange={{
                        ru: (e) => onChange(constants.PARTICIPANT_REGALIA_RU, e.target.value),
                        en: (e) => onChange(constants.PARTICIPANT_REGALIA_EN, e.target.value),
                    }}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>{participantFormFields[constants.FIELD_BIOGRAPHY]}</ControlLabel>
                <FormControlLanguage
                    type="textarea"
                    rows={4}
                    placeholder="Введите описание / биографию участника"
                    values={{
                        ru: model?.[constants.PARTICIPANT_BIOGRAPHY_RU] || '',
                        en: model?.[constants.PARTICIPANT_BIOGRAPHY_EN] || '',
                    }}
                    onChange={{
                        ru: (e) => onChange(constants.PARTICIPANT_BIOGRAPHY_RU, e.target.value),
                        en: (e) => onChange(constants.PARTICIPANT_BIOGRAPHY_EN, e.target.value),
                    }}
                />
            </FormGroup>
            <Row>
                <Col xs={4}>
                    <FormGroup>
                        <ControlLabel>{participantFormFields[constants.FIELD_TELEGRAM]}</ControlLabel>
                        <FormControl
                            type="text"
                            placeholder="Введите ссылку на телеграм"
                            value={model?.[constants.PARTICIPANT_TELEGRAM] || ''}
                            onChange={(e) => onChange(constants.PARTICIPANT_TELEGRAM, e.target.value)}
                        />
                    </FormGroup>
                </Col>
                <Col xs={4}>
                    <FormGroup>
                        <ControlLabel>{participantFormFields[constants.FIELD_VK]}</ControlLabel>
                        <FormControl
                            type="text"
                            placeholder="Введите ссылку на ВКонтакте"
                            value={model?.[constants.PARTICIPANT_VK] || ''}
                            onChange={(e) => onChange(constants.PARTICIPANT_VK, e.target.value)}
                        />
                    </FormGroup>
                </Col>
                <Col xs={4}>
                    <FormGroup>
                        <ControlLabel>{participantFormFields[constants.FIELD_DZEN]}</ControlLabel>
                        <FormControl
                            type="text"
                            placeholder="Введите ссылку на Дзен"
                            value={model?.[constants.PARTICIPANT_DZEN] || ''}
                            onChange={(e) => onChange(constants.PARTICIPANT_DZEN, e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </FormGroup>
    );
};

export default ParticipantFields;
